import { pxToRem } from './utils/pxToRem';

export const Measures = {
  content: {
    constrained: pxToRem(1300),
  },
  border: {
    regular: '1px',
  },
  breakpoints: {
    mobileSm: '23.4em',
    mobileLg: '41.6em',
    tabletSm: '48em',
    tabletLg: '64em',
    laptop: '90em',
    desktop: '105em',
  },
  rules: {
    hr1: '1px',
    hr2: '2px',
    hr3: '3px',
    hr4: '4px',
    hr5: '5px',
  },
  spacing: [4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80],
};
